// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3F7VT","inner":"Form_inner__i-zuS","range":"Form_range__dQql9","name":"Form_name__32J2w","actions":"Form_actions__JeACX"};